<template>
    <div class="home-user">
      <heading title="Equipment Owner Dashboard" tag="home-equipment-title">
        <template v-for="(company, i) in companies">
          <router-link :to="`/company/view/${company.id}`" :key="`company-link-${i}`">
            {{ company.name }}
          </router-link>
        </template>
      </heading>
        <b-row>
            <div class="col-lg-6">
                <notification-list-widget/>
            </div>
            <div class="col-lg-6">
                <message-list-widget/>
            </div>
        </b-row>
        <b-row>
            <div class="col-lg-6">
                <equipment-list-widget/>
            </div>
            <div class="col-lg-6">
                <staff-list-widget/>
            </div>
        </b-row>
        <b-row>
            <div class="col-lg-12">
                <project-list-widget/>
            </div>
        </b-row>
    </div>
</template>

<script>

import Vue from 'vue'
//import MapSelector from '@/components/MapSelector'

export default Vue.extend({
    name: 'HomeUser',
    components: {},
    data() {
      return {
        companies: []
      }
    },
    methods: {
        mapdate (val) {
            console.log(val)
        }
    },
    mounted() {
      this.$api.getItem(this, 'user', this.$user.userId())
          .then(data => this.companies = data.companies)
    }
})
</script>
